import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import './payments.css'

import { DomainContext } from '../../domain-repository/DomainRepository'

import { saveSessionEnd, setPageId } from '../../services/Metrics'

import { getQueryStringParams } from '../../utils/utils'

import withLang from '../../withLang'
import TrackingPage from '../../components/TrackingPage'
import { PaymentsForm } from './PaymentsForm'
import Loading from '../../components/Loading'
import { getReservation } from '../../services/GetReservation'

function PaymentsReminderPage(props) {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(true)

  const {
    appVersionId,
    language,
    setSessionId,
    setReservation,
  } = useContext(DomainContext)

  useEffect(() => {
    const queryStringValues = getQueryStringParams(
      props.location && props.location.search ? props.location.search : null
    )
    if (!queryStringValues || !queryStringValues.number || !queryStringValues.pickupStation || !queryStringValues.pickupDate) {
      return props.history.push(`/payments-error`)
    }
    setIsLoading(true)
    getReservation({
      resNumberOrReference: queryStringValues.number,
      stationId: queryStringValues.pickupStation,
      resCheckOutDate: queryStringValues.pickupDate,
      appVersionId, language, autoSearch: true, paymentsSession: true
    })
      .then(reservation => {
        if (!reservation) {
          return props.history.push(`/payments-error`)
        }
        setSessionId(reservation.sessionId)
        setReservation(reservation)

        setIsLoading(false)
      })
      .catch(err => {
        props.history.push(`/payments-error`)
      })

  }, [])

  if (isLoading) {
    return <Loading active={isLoading} />
  }

  return (
    <div className="container">
      <div className="row justify-content-center text-center">
        <div className="col-5 mt-5">
          <div>
            <img onClick={() => props.history.push('/start')} src={require(`../../assets/images/logo.png`)} alt="Guerin" className="img-fluid pt-3 pb-3" />
          </div>
        </div>
      </div>
      <PaymentsForm nextPageUrl='/thank-you' />
    </div>
  )
}

export default withLang(PaymentsReminderPage)
